import { useApi } from 'api/api-context';
import PredefinedDataTable from 'components/tables/data/predefined/PreDefinedDataTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { ADD_USERS_PREDEFINED_DATA_PAGE_PATH, EDIT_USERS_PREDEFINED_DATA_PAGE_PATH } from 'routes/paths';

/**
 * Page used to display user's pre-defined data.
 *
 */
export default function UsersPredefinedDataPage() {
  const { getAction } = useApi();

  return (
    <DashboardLayout breadcrumbs={[{ title: 'Nastavenia' }, { title: 'Predvolené údaje' }]} height="screen">
      <PredefinedDataTable
        action={getAction('PredefinedDataListUsers')}
        addPath={ADD_USERS_PREDEFINED_DATA_PAGE_PATH.original}
        editPath={EDIT_USERS_PREDEFINED_DATA_PAGE_PATH}
        tableType="user"
      />
    </DashboardLayout>
  );
}
